if (!customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.style.height = this.firstElementChild.clientHeight + 'px';

      ['scroll', 'load'].forEach((event) =>
        window.addEventListener(event, this.handleSticky.bind(this)),
      );
    }

    handleSticky() {
      this.classList.toggle(
        'is-sticky',
        this.getBoundingClientRect(this).top < 0,
      );
    }
  }
  customElements.define('sticky-button', StickyButton);
}
